import { PaginationBase } from "@faire/web/slate/Pagination/PaginationBase";
import { legacyComponentCls } from "@faire/web/slate/utils/tracking";
import { LocationDescriptor } from "history";
import * as React from "react";

import { IPaginationData } from "./utils";

export namespace Pagination {
  export interface IProps {
    /**
     * Keep the pagination rendering even when there's exactly one page of results.
     * By default, the component won't render itself when there's less than 2 pages.
     */
    showWhenSinglePage?: boolean;
    /**
     * Pagination data, usually returned from a backend api, containing
     * information on the current page number, the size of the page, the
     * total number of pages, and the total number of results.
     */
    paginationData: IPaginationData;
    /** Factory for currying a link URL from a page number. */
    pageToLink: (page: number) => LocationDescriptor;
    /** Callback handler called when a page link is clicked in the pagination component. */
    onChangePage?: (
      page: number,
      event: React.MouseEvent<HTMLElement, MouseEvent>
    ) => void;
    className?: string;
    disableButton?: boolean | ((page: number) => boolean);
  }
}

/**
 * @deprecated Use `Pagination` from `@faire/slate/components/pagination` instead - since 2025-08-07
 */
export const Pagination: React.FC<Pagination.IProps> = ({
  className,
  ...props
}) => <PaginationBase {...props} className={legacyComponentCls(className)} />;
